/**
 * The shape of what is loading, in place of the word "Loading…".
 *
 * **The portal used to answer every wait with one line of grey text on an empty page**, which tells
 * a customer nothing about whether their case is about to appear or their session has quietly
 * ended. Drawing the layout that is coming keeps the page from jumping when it arrives and makes a
 * slow connection look slow rather than broken.
 *
 * `aria-hidden`, and the container that holds these carries the live region. Announcing eleven grey
 * rectangles is not a description of anything.
 */
export function Skeleton({ className = '' }: { className?: string }) {
    return (
        <span
            aria-hidden="true"
            className={`block animate-pulse rounded-lg bg-slate-200/70 dark:bg-slate-800 ${className}`}
        />
    );
}
